<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            报告单号：<span v-if="formData.reportNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.reportNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 新增</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
                  '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消' : '取消'
              }}</span>

          </div>
          <div class="fr" v-show="btn_no">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
              v-if="editButton && (formData.stat == 1 || formData.stat == 6)" @click="saveData">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
              v-if="formData.id != null && (formData.stat == 1) && !formData.processId && submitButton"
              @click="showCloseDialog = true; type = '提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
              v-if="formData.id != null && formData.stat == 2 && !formData.processId && checkButton"
              @click="showCloseDialog = true; type = '审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
              v-if="formData.id != null && formData.stat == 2 && !formData.processId && rejectButton"
              @click="showCloseDialog = true; type = '驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
              v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButton"
              @click="showCloseDialog = true; type = '取消'">取消
            </el-button>
          </div>

        </div>

        <div>

          <!-- 基本信息 -->
          <div style="overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important;display: block ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>基本信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <!-- <th>
                      <em class="f-red">*</em>

                        报告单号</th>
                      <td><el-input type="text" autocomplete="off" v-model="formData.outOrderNo"  clearable/></td> -->
                      <th>
                        <em class="f-red">*</em>

                        单据状态
                      </th>
                      <td>
                        <el-select v-model="formData.stat" clearable disabled>
                          <el-option label="制单" :value="1" />
                          <el-option label="审核中" :value="2" />
                          <el-option label="已审核" :value="5" />
                          <el-option label="驳回" :value="6" />
                          <el-option label="取消" :value="99" />
                        </el-select>
                      </td>
                      <!-- <th>
                      <em class="f-red">*</em>
                      网点
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.siteName"
                                clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showSitePop=true"></i>
                      </el-input>
                    </td> -->
                      <th>工单号</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.orderNo" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showOrderPop = true"></i>
                        </el-input>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        申请赔偿金额
                      </th>
                      <td>
                        <el-input type="number" autocomplete="off" v-model="formData.applyPayMoney" :maxlength="8" oninput="if(value.length>8){value=value.substring(0, 8)}" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        实际赔偿金额
                      </th>
                      <td>
                        <el-input type="number" autocomplete="off" v-model="formData.realPayMoney" :maxlength="8" oninput="if(value.length>8){value=value.substring(0, 8)}" clearable />
                      </td>
                    </tr>


                    <tr>

                      <th>
                        <em class="f-red">*</em>
                        部门名称
                      </th>
                      <td>
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"
                          :props="{ label: 'name', value: 'id', checkStrictly: true }" />
                      </td>
                      <!-- <td v-else>
                        <el-cascader v-model="orgValue" :options="orgOptions" :props="{  checkStrictly: true }" @change="orgHandleChange"/>
                      </td> -->

                      <th>
                        <em class="f-red">*</em>
                        网点
                      </th>
                      <td v-if="justShow">{{ formData.siteName }}</td>
                      <td v-else-if="this.currentSiteData !== null">
                        <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                        </el-input>
                      </td>


                      <th>联系人</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.siteMan" clearable />
                      </td>
                      <th>联系人电话</th>
                      <td>
                        <!-- <el-input type="text" autocomplete="off" v-model="formData.siteManMobile"
                          clearable /> -->
                        <el-input type="text" autocomplete="off" v-model="callMobile1" clearable />

                      </td>

                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>

                        紧急程度
                      </th>
                      <td>
                        <el-select v-model="formData.urgencyType" clearable>
                          <el-option v-for="item in urgencyTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>

                        事故类型
                      </th>
                      <td>
                        <el-select v-model="formData.accidentType" clearable>
                          <el-option v-for="item in accidentTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>

                        鉴定方式
                      </th>
                      <td>
                        <el-select v-model="formData.identifyType" clearable>
                          <el-option v-for="item in identifyTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        完工日期</th>
                      <td>
                        <el-date-picker v-model="formData.completeTime" type="date" value-format="yyyy-MM-dd 00:00:00"
                          placeholder="选择日期">
                        </el-date-picker>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        是否质量问题
                      </th>
                      <td>
                        <el-select v-model="formData.qualityType" clearable>
                          <el-option label="否" :value="0" />
                          <el-option label="是" :value="1" />
                        </el-select>
                      </td>
                      <th>回执单号</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.receiptNo" clearable />
                      </td>
                      <th>快递单号</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.logisticsNo" clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        报告描述
                      </th>
                      <td colspan="7">
                        <!-- <el-input type="text" autocomplete="off" v-model="formData.reportRemark" clearable /> -->
                        <el-input  type="textarea" :autosize="{ minRows: 3, maxRows: 6}" autocomplete="off" v-model="formData.reportRemark" oninput="if(value.length>1000){value=value.substring(0, 1000)}"
                          clearable />
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>用户信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>

                      <th><em class="f-red">*</em>用户档案</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.profileNo" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showCustProfile = true"></i>
                        </el-input>
                      </td>

                      <th><em class="f-red">*</em>用户姓名</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userName" disabled clearable />
                      </td>

                      <th><em class="f-red">*</em>用户电话</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userMobile" clearable />
                      </td>

                    </tr>

                    <tr>
                      <th>
                        <em class="f-red">*</em>地区
                      </th>

                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" style="width:100%;"
                              @change="handleChange" ref="cascader" :options="areaOption">
                            </el-cascader>
                          </template>
                        </el-form-item>
                      </td>

                      <th>
                        <em class="f-red">*</em>详细地址
                      </th>
                      <td v-if="justShow">{{ formData.userAddress }}</td>
                      <td v-else colspan="3">
                        <el-input type="text" autocomplete="off" v-model="formData.userAddress" clearable />
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>产品信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <!-- <em class="f-red">*</em> -->
                        产品编码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemCode" @change="changeItemCode()"
                          clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search"
                            @click="showPreconditionDialog = true"></i>
                        </el-input>
                      </td>
                      <th>
                        <!-- <em class="f-red">*</em> -->
                        产品名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable disabled>
                        </el-input>
                      </td>

                      <th>
                        <!-- <em class="f-red">*</em> -->
                        产品条码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.barcode" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        产品分类
                      </th>
                      <td>
                        <el-select v-model="formData.bigCategoryId" placeholder="大类" @change='productSelectOne' clearable
                          style="width: 49%!important;">
                          <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-select v-model="formData.smallCategoryId" placeholder="小类" clearable
                          style="width: 49%!important;margin-left:2%;">
                          <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>

                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        购买日期
                      </th>
                      <td>
                        <el-date-picker v-model="formData.buyDate" type="date" value-format="yyyy-MM-dd 00:00:00"
                          placeholder="选择日期">
                        </el-date-picker>
                      </td>


                      <th>
                        气源名称
                      </th>
                      <td>
                        <el-select v-model="formData.gasType" clearable>
                          <el-option v-for="item in dictTypesGasType" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>


                    </tr>

                    <!-- <tr>

                     <th>
                      视频
                     </th>
                     <td>
                     <div>
             <video-upload :photo-url.sync="videoUrl"/>
           </div>
                     </td>
                   </tr> -->
                  </tbody>
                </table>
              </div>


              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>附件列表</b></div>
                  <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                    :action="api.uploadFileUrl"  :show-file-list="false"
                    :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                    :on-progress="upVideo"

                    :auto-upload="true">
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent" :data="fileList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{ row }">
                        <!-- <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> -->
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{ row }">
                        <div>
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>

                
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>中心附件列表</b></div>
                  <!-- <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                    :action="api.uploadFileUrl"  :show-file-list="false"
                    :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                    :on-progress="upVideo"

                    :auto-upload="true">
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload> -->
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow height="210" :column-config="{ resizable: true }" 
                    :data="orgFileList">
                    <!-- @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent"  -->
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{ row }">
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="type" title="类型" width="400">
                      <template #default="{ row }">
                        <span v-if="row.type == 0">审核</span>
                        <span v-if="row.type == 1">鉴定</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{ row }">
                        <div>
                          <!-- <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="deleteFileOrg(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip> -->

                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>

              <wfView visible-key="showEdit" :wfData="wfData" :parent-target="_self" @reloadWf="reloadWf"></wfView>

              <div style="height:250px"></div>
            </div>
          </div>

        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" :orgId="formData.orgId" multi="true" />

    <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :siteId="formData.siteId" :rhs="true"
      multi="true" />

    <custProfileDialog v-if="showCustProfile" @commit="custProfileCommit" :visiable.sync="showCustProfile" multi="true" />

    <warehousePop v-if="showWarehousePop" :warehouseType="warehouseType" @commit="warehouseCommit"
      :visiable.sync="showWarehousePop" multi="true" />

    <partsInvPop v-if="showPartsInvPop" @confirm="confirm" :visiable.sync="showPartsInvPop" multi="true" />

    <auditDialog v-if="showAuditDialog" :form-data="formData" :shippingMethodList="shippingMethodList" @closeD="closeD"
      :visiable.sync="showAuditDialog" multi="true" @goBackIndex="goBackIndex" />

    <outboundDialog v-if="showOutboundDialog" :form-data="formData" :shippingMethodList="shippingMethodList"
      :logisticsCompaniesList="logisticsCompaniesList" @closeD="closeD" :visiable.sync="showOutboundDialog" multi="true"
      @goBackIndex="goBackIndex" />

    <!--<closeDialog v-if="showCloseDialog" :dataId="formData.id" :stat="formData.stat" @closeD="closeD"
      :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" :isCancel="isCancel" />-->
    <closeDialog v-if="showCloseDialog" :dataId="formData.id" :confirmNo="formData.reportNo" :type="type" @closeD="closeD"
      :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" />
    <!-- 产品弹窗 -->
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
      :visiable.sync="showPreconditionDialog" multi="true" />
                <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'

import custProfileDialog from '@/views/dialogCommon/custProfileListDialog.vue'

import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import { dictType, loadDictData } from "@/config/dictType";
import partsInvPop from '@/views/dialogCommon/partsInvDialog.vue';
import auditDialog from "./auditDialog.vue";
import closeDialog from "./closeDialog.vue";
import outboundDialog from "./outboundDialog.vue";

// 产品弹窗
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue"
import { fetchTree, fetchTree2 } from "@/api/admin/type_tree";
import { mapGetters } from "vuex";
import { siteMixins } from "@/mixins/tabChang";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
// 视频
import videoUpload from "@/components/formItem/videoUpload.vue"
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    btn_no: {
      type: Boolean,
      default: true
    },

    type: String
  },
  components: {Preview,videoUpload, wfView, auditDialog, closeDialog, outboundDialog, orderPop, sitePop, warehousePop, partsInvPop, preconditionDialog, ItemCategorySelect, custProfileDialog, },
  data() {
    return {
      imgVisbleURL: '',

showPreview: false,
videoUrl:'',

      callMobile1: '',

      // 查询参数
      queryParams: {
        deptName: ""
      },
      fileList: [],
      orgFileList: [],

      btn_no: true,
      editButton: false,
      // 流程
      processId: '',

      wfData: {
        wfEntityId: ''
      },
      showEdit: false,

      urgencyTypeObj: {},
      urgencyTypeList: [],
      accidentTypeObj: {},
      accidentTypeList: [],
      identifyTypeObj: {},
      identifyTypeList: [],
      gasTypeObj: {},
      dictTypesGasType: [],
      productOptions0: [],
      productOptions1: [],

      showPreconditionDialog: false,

      warehouseType: 0,
      justShow: false,
      showPartsInvPop: false,
      showSitePop: false,
      showCustProfile: false,
      showOrderPop: false,
      showWarehousePop: false,
      showAuditDialog: false,
      showOutboundDialog: false,
      showCloseDialog: false,
      isCancel: false,
      orgOptions: {},
      orgValue: '',
      areaOption: [],
      areaValues: [],
      selectedData: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],
      picList1: [],
      picList2: [],
      picList3: [],
      showPhotoList: [],
      formData: {
        outWarehouseName: null,

        reportNo: null, //报告单号;自动生成:AR+年月日时分秒+2位随机数
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        orderId: null, //工单id，关联so_order.id
        orderNo: null, //工单号，冗余字段
        urgencyType: null, //紧急程度ID,关联脚手架数据字典项目表sys_dict_item.id
        urgencyTypeName: null, //紧急程度名称，冗余字段
        accidentType: null, //事故类型ID，关联脚手架数据字典项目表sys_dict_item.id
        accidentTypeName: null, //事故类型名称，冗余字段
        identifyType: null, //鉴定方式ID，关联脚手架数据字典项目表sys_dict_item.id
        identifyTypeName: null, //鉴定方式名称，冗余字段
        applyPayMoney: 0, //申请赔偿金额
        realPayMoney: 0, //实际赔偿金额
        siteId: null, //服务商ID,关联sn_user.id;
        siteName: null, //服务商名称
        siteMan: null, //联系人
        siteManMobile: null, //联系人电话
        orgId: null, //部门ID，关联脚手架机构表sys_dept.dept_id
        orgName: null, //部门名称,冗余字段
        orgIdPath: null, //部门ID路径,冗余字段.重要
        qualityType: null, // 是否质量问题
        receiptNo: null, //回执单号
        logisticsNo: null, //快递单号
        completeTime: null, //完工日期
        reportRemark: null, //报告描述
        userName: null, //用户姓名
        userMobile: null, //用户电话
        userProvince: null, //省
        userCity: null, //市
        userCounty: null, //县
        userTown: null, //镇街
        areaId: null, //地区ID,关联bas_area.id
        userAddress: null, //详细地址
        itemId: null, //产品Id,关联bas_item.id
        itemCode: null, //产品编码,冗余字段
        itemName: null, //产品名称,冗余字段
        bigCategoryId: null, //产品大类ID,关联bas_item_category.id
        bigCategoryName: null, //产品大类名称。冗余字段
        smallCategoryId: null, //产品小类ID,关联bas_item_category.id
        smallCategoryName: null, //产品小类名称。冗余字段
        gasType: null, //气源ID，关联脚手架数据字典项目表sys_dict_item.id
        gasTypeName: null, //气源名称，冗余字段
        barcode: null, //产品条码
        buyDate: null, //购买日期
        profileId: null, //用户档案Id,关联bas_cust_profile.id
        profileNo: '',
        fileList: [],
        orgFileList: [],


      },

      show3: false,
      node: true,


      srcList: [],


      ////////////////////////////////////////////////////////////////////////////////////////////


      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.btn_no) this.btn_no = this.btn_no;

    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;

    this.editButton = this.permissions["wkAccidentReportEdit"];
    this.submitButton = this.permissions["wkAccidentReportSubmit"]; //提交
    this.checkButton = this.permissions["wkAccidentReportCheck"]; //审核
    this.rejectButton = this.permissions["wkAccidentReportReject"]; //驳回
    this.cancelButton = this.permissions["wkAccidentReportCancel"]; //取消
  },
  mounted() {
    this.loadOrgData()
    this.loadDictData()
    this.loadProductOption0()
    this.loadProductOption1()
    this.getData()

  },
  watch: {
    // 联系方式验证
    // callMobile1: {
    //   handler(newVal, oldVal) {
    //     // console.log(newVal,"新值");
    //     this.formData.siteManMobile = newVal

    //     var numReg = /^[0-9]+$/
    //     var numRe = new RegExp(numReg)
    //     if (!numRe.test(this.formData.siteManMobile)) {
    //       this.$message.error("请输入正确的11位手机号码");
    //     } else if (this.formData.siteManMobile.length > 11) {
    //       this.$message.error("手机号码不能超过11位");
    //       this.formData.siteManMobile = this.formData.siteManMobile.slice(0, 11);
    //       this.callMobile1 = this.formData.siteManMobile
    //     }
    //   },
    //   deep: true, // 加这个属性，深度监听
    // },
    selectedRow: {
      handler(newVal, oldVal) {
        this.formData.itemId = newVal.id
        this.formData.itemCode = newVal.code
        this.formData.itemName = newVal.name
      },
      deep: true
    },
    'formData.outType': {
      handler(n) {
        if (n == 1) {  // 总部
          this.warehouseType = 0
        } else if (n == 2) {   // 中心
          this.warehouseType = 1
        }
      },
      deep: true
    },
    'formData.spPartsApplyLineDTOList': {
      handler(n) {
        if (n) {
          let temp = 0
          let temp1 = 0
          n.forEach(item => {
            temp += Number(item.applyQty)
            temp1 += Number(item.applyQty) * Number(item.sitePrice)
          })
          this.formData.applyQtyAll = temp
          this.formData.applyAmountAll = temp1
        }
      },
      deep: true
    }
  },
  methods: {
    closeD2() {
      this.showPreview = false

    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    reloadWf() {
      console.log('保存前的刷新');
      this.$emit('editViewDataUpdate')
    },
    upVideo(){
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
          message: '附件上传成功',
          type: 'success'
        });
        this.$mask.close()
    },
    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.fileList = this.fileList.filter(item => item.url !== row.url)
      })
    },
    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },
    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },
    // 产品大类选中加载小类
    productSelectOne() {
      this.productOptions1 = []
      this.formData.smallCategoryId = null
      this.loadProductOption1()
    },

    commitSelectedRow(data) {
      console.log(data, 'this.selectedRow传过来的值  编码');
      this.formData.itemId = data.id
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryName = data.smallCategoryName
      if(data.barcode != null && data.barcode != 0){
        this.formData.barcode = data.barcode
      }
      this.loadProductOption1()
    },
    //清空产品
    changeItemCode() {
      this.formData.itemId = "";
      this.formData.itemCode = "";
      this.formData.itemName = "";
      this.formData.bigCategoryId = "";
      this.formData.smallCategoryId = "";
      this.formData.bigCategoryName = "";
      this.formData.smallCategoryName = "";
    },
    showPartsInvPopFunc() {

      this.showPartsInvPop = true

    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 添加明细
    confirm(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null) {
        temp = []
      }
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.price,
          applyQty: 1,
          applyAmount: item.price,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
      this.showOutboundDialog = false
    },


    deleteData() {
      let temp = this.formData.spPartsApplyLineDTOList
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.selectId != item.selectId)
      })
      this.formData.spPartsApplyLineDTOList = temp
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })

      // 运输方式
      loadDictData(dictType.shippingMethod).then(res => {
        this.shippingMethodList = []
        res.data.data.forEach(item => {
          this.shippingMethodList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      // 紧急程度
      loadDictData('紧急程度').then(res => {
        this.urgencyTypeList = []
        res.data.data.forEach(item => {
          this.urgencyTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      // 事故类型
      loadDictData('事故类型').then(res => {
        this.accidentTypeList = []
        res.data.data.forEach(item => {
          this.accidentTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      // 鉴定方式
      loadDictData('鉴定方式').then(res => {
        this.identifyTypeList = []
        res.data.data.forEach(item => {
          this.identifyTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      // 气源名称
      loadDictData('气源名称').then(res => {
        this.dictTypesGasType = []
        res.data.data.forEach(item => {
          this.dictTypesGasType.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },


    // 工单弹框选中
    orderCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.orderNo = data.orderNo
      this.formData.userName = data.userName
      this.formData.userMobile = data.userMobile
      this.formData.siteId = data.siteId
      this.formData.siteName = data.siteName
      this.formData.siteMan = data.siteMan
      this.formData.siteManMobile = data.siteManMobile
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
      this.formData.areaId = data.areaId
      this.formData.userProvince = data.userProvice
      this.formData.userCity = data.userCity
      this.formData.userCounty = data.userCounty
      this.formData.userTown = data.userTown
      this.formData.userAddress = data.userAddress
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryName = data.smallCategoryName
      this.formData.buyDate = data.buyDate
      this.formData.profileId = data.profileId
      this.formData.completeTime = data.completeTime
      this.formData.barcode = data.resultBarcode
      this.loadCustProfile()
      this.echoAddress()
      this.loadProductOption1()
    },

    // 用户档案弹框选中
    custProfileCommit(data) {
      console.log('选中的用户', data)
      this.formData.profileId = data.id
      this.formData.profileNo = data.profileNo
      this.formData.userType = data.userType
      this.formData.userMobile = data.callMobile
      this.formData.userName = data.custName
      /*this.formData.orgName = data.orgName*/
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree2(this.queryParams).then(response => {
        this.orgOptions = response.data.data
        // this.orgOptions =res.data.data
        console.log(this.orgOptions, "this.orgOptions的值");

      });

    },
    // loadOrgData() {
    //   this.$http({
    //     url: api.sysDept.getDataUrl,
    //     method: 'post',
    //     data: {}
    //   }).then(res => {
    //     console.log(res.data.data,"机构的值")
    //     this.orgOptions = []
    //     res.data.data.forEach(item => {
    //       let temp = {
    //         value: item.id,
    //         label: item.name,
    //       }
    //       if (item.hasChild) {
    //         temp.children = []
    //         item.child.forEach(item1 => {
    //           temp.children.push({
    //             value: item1.deptId,
    //             label: item1.name
    //           })
    //         })
    //       }
    //       this.orgOptions.push(temp)
    //     })
    //   })
    // },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userTown = null;
          this.formData.userCounty = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId != 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.areaId }
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },

    //用户档案回显
    loadCustProfile() {
      if (this.formData.profileId !== null && this.formData.profileId !== '' && this.formData.profileId != 0) {
        this.$http({
          url: api.basCustProfile.getDataUrl,
          method: 'post',
          data: { id: this.formData.profileId }
        }).then(res => {
          console.log("用户档案回显：" + res.data.data)
          this.formData.profileNo = res.data.data.profileNo
        })
      }
    },


    saveData() {
      if (this.formData.urgencyType) {
        this.urgencyTypeList.forEach(item => {
          if (this.formData.urgencyType === item.value) {
            this.formData.urgencyTypeName = item.label
          }
        })
      }
      if (this.formData.accidentType) {
        this.accidentTypeList.forEach(item => {
          if (this.formData.accidentType === item.value) {
            this.formData.accidentTypeName = item.label
          }
        })
      }
      if (this.formData.identifyType) {
        this.identifyTypeList.forEach(item => {
          if (this.formData.identifyType === item.value) {
            this.formData.identifyTypeName = item.label
          }
        })
      }
      if (this.formData.gasType) {
        this.dictTypesGasType.forEach(item => {
          if (this.formData.gasType === item.value) {
            this.formData.gasTypeName = item.label
          }
        })
      }

      this.formData.pic1 = uploadFileFormat(this.picList1)
      this.formData.pic2 = uploadFileFormat(this.picList2)
      this.formData.pic3 = uploadFileFormat(this.picList3)
      let deliverType = this.formData.deliverType;
      if (deliverType) {
        this.shippingMethodList.forEach(item => {
          if (deliverType === item.value) {
            this.formData.deliverTypeName = item.label
          }
        })
      }

      let deliverCompany = this.formData.deliverCompany;
      if (deliverCompany) {
        this.logisticsCompaniesList.forEach(item => {
          if (deliverCompany === item.value) {
            this.formData.deliverCompanyName = item.label
          }
        })
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            this.formData.siteManMobile = this.callMobile1
            this.formData.vedioUrl=this.videoUrl//视频url


            this.formData.fileList = this.fileList
            console.log(this.formData.fileList, 'this.formData.fileList的值');
            var url = (this.isEdit ? api.wkAccidentReport.updateDataUrl : api.wkAccidentReport.addDataUrl);
            var method = (this.isEdit ? 'put' : 'post');
            this.$http({
              url: url,
              method: method,
              data: this.formData,
              isLoading: true,
            }).then(response => {
              //this.$message.success("保存成功！");
              this.$mask.close()
              if (response.data.type == "success") {
                this.$message({ message: response.data.content, type: 'success' });
                this.reload()
              } else {
                this.$message({ message: response.data.content, type: 'warning' });
              }
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    getData() {
      // console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkAccidentReport.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.spPartsApplyOperationDTOList === null || data.spPartsApplyOperationDTOList === undefined) {
            data.spPartsApplyOperationDTOList = []
          }
          this.formData = data
         this.videoUrl =this.formData.vedioUrl//视频url

          this.callMobile1 = this.formData.siteManMobile

          this.fileList = this.formData.fileList
          this.orgFileList = this.formData.orgFileList

          if (this.justShow) {
            this.showPhotoList = [data.pic1, data.pic2, data.pic3]
          } else {
            this.picList1 = echoFileFormat(data.pic1)
            this.picList2 = echoFileFormat(data.pic2)
            this.picList3 = echoFileFormat(data.pic3)
            this.orgValue = data.orgId
            this.echoAddress()
            this.loadProductOption1()
          }

          this.justShow = this.formData.stat != 1


        })
      } else { //新建
        this.enabled = true;
        if (this.currentSiteData !== null) { //网点端
          console.log("this.currentSiteData", this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList1 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}


.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}



.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}




::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}



#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
